import { render, staticRenderFns } from "./Form.vue?vue&type=template&id=8b3778b4"
import script from "./Form.vue?vue&type=script&lang=js"
export * from "./Form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ScMutationForm: require('/opt/build/repo/node_modules/@evince/core/lib/components/MutationForm.vue').default})
